import { request } from '@@/plugin-request';

export async function queryFirstLessonCommunicationTasks(params) {
  return request('/api/educationalResearchTasks/firstLessonCommunicationTasks', {
    method: 'GET',
    params,
  });
}

export async function checkConflictFirstLessonCommunication(payload) {
  return request('/api/preClassCommunication/checkConflicts', {
    method: 'POST',
    data: payload,
  });
}

export async function createFirstLessonCommunication(payload) {
  return request('/api/preClassCommunication', {
    method: 'POST',
    data: payload,
  });
}

export async function updateFirstLessonCommunication(payload) {
  return request('/api/preClassCommunication', {
    method: 'PUT',
    data: payload,
  });
}

export async function addPreClassCommunicationNote(payload) {
  return request('/api/educationalResearchTasks/addPreClassCommunicationNote', {
    method: 'POST',
    data: payload,
  });
}
